import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { TimeIcon } from '@icons/TimeIcon';
import { UsersIcon } from '@icons/UsersIcon';
import { Switch } from '@components/Switch';
import { ToolTip } from '@insights_module/components/ToolTip';
import { DownloadTranscriptButton } from '@insights_module/components/episode_details_screen/DownloadTranscriptButton';
import { DownloadGarmButton } from '@insights_module/components/episode_details_screen/EpisodeGarmSection';
import { DownloadContextualButton } from '@insights_module/components/episode_details_screen/EpisodeContextualSection';
import { DownloadEntitiesButton } from '@insights_module/components/episode_details_screen/EpisodeEntitiesSection';
import { useEpisodeDetailsContext } from '@insights_module/context/EpisodeDetailsContext';
import { useNotification } from '@insights_module/hooks/useNotification';

const FlexStart = tw.div`w-full flex items-center justify-start gap-[6px]`;
const TogglerCopy = tw.span`text-[14px] text-text-and-icon`;
const ButtonsWrapper = tw.div`flex flex-col gap-[12px]`;
const TogglerWrapper = tw.div`w-full flex items-center justify-between border border-solid border-sec-2 py-[10px] px-[12px] rounded-[6px] bg-neutral-background [&_svg]:stroke-current [&_svg]:w-4 [&_svg]:h-4 text-text-and-icon`;
const TogglerLabel = tw.label`text-[14px] text-text-and-icon cursor-pointer select-none	`;

export const EpisodeTranscriptControls = () => {
  const { t } = useTranslation();
  const { activeView, setShowTranscriptTimestamps, setShowSpeakerLabel, hasDiarizedTranscript } =
    useEpisodeDetailsContext();
  const { notify, NTFC_TYPE } = useNotification();

  const tooltipMessage = hasDiarizedTranscript
    ? t('insights.episode_details_drawer.episode_details_sidebar.transcript.tooltip.diarization')
    : t(
        'insights.episode_details_drawer.episode_details_sidebar.transcript.tooltip.no_diarization'
      );

  return (
    <ButtonsWrapper>
      {activeView === 'speakers' && <DownloadTranscriptButton />}
      {activeView === 'garm_brand_safety' && <DownloadGarmButton />}
      {activeView === 'entities' && <DownloadEntitiesButton />}
      {activeView === 'iab_categories' && <DownloadContextualButton />}

      {activeView === 'speakers' && (
        <TogglerWrapper
          tw='pr-[-16px]'
          onClick={() => {
            if (!hasDiarizedTranscript) {
              notify({
                type: NTFC_TYPE.INFO,
                message: t(
                  'insights.episode_details_drawer.episode_details_sidebar.transcript.tooltip.no_diarization'
                ),
              });
            }
          }}>
          <FlexStart>
            <UsersIcon />
            <TogglerCopy>
              {t('insights.episode_details_drawer.episode_details_sidebar.transcript.speakers')}
            </TogglerCopy>
          </FlexStart>
          <ToolTip content={tooltipMessage} placement='right'>
            <Switch
              id='speakers'
              name='speakers'
              onChange={(val) => setShowSpeakerLabel(val)}
              isActive={hasDiarizedTranscript}
              height={20}
              width={38}
              disabled={!hasDiarizedTranscript}
            />
          </ToolTip>
        </TogglerWrapper>
      )}
      <TogglerWrapper>
        <FlexStart>
          <TimeIcon />
          <TogglerLabel htmlFor='timestamps'>
            {t('insights.episode_details_drawer.episode_details_sidebar.timestamps')}
          </TogglerLabel>
        </FlexStart>
        <Switch
          id='timestamps'
          name='timestamps'
          isActive={true}
          onChange={(val) => setShowTranscriptTimestamps(val)}
          height={20}
          width={38}
        />
      </TogglerWrapper>
    </ButtonsWrapper>
  );
};
